export enum USStateCode {
  AL = 'AL',
  AK = 'AK',
  AS = 'AS',
  AZ = 'AZ',
  AR = 'AR',
  CA = 'CA',
  CO = 'CO',
  CT = 'CT',
  DE = 'DE',
  DC = 'DC',
  FM = 'FM',
  FL = 'FL',
  GA = 'GA',
  GU = 'GU',
  HI = 'HI',
  ID = 'ID',
  IL = 'IL',
  IN = 'IN',
  IA = 'IA',
  KS = 'KS',
  KY = 'KY',
  LA = 'LA',
  ME = 'ME',
  MH = 'MH',
  MD = 'MD',
  MA = 'MA',
  MI = 'MI',
  MN = 'MN',
  MS = 'MS',
  MO = 'MO',
  MT = 'MT',
  NE = 'NE',
  NV = 'NV',
  NH = 'NH',
  NJ = 'NJ',
  NM = 'NM',
  NY = 'NY',
  NC = 'NC',
  ND = 'ND',
  MP = 'MP',
  OH = 'OH',
  OK = 'OK',
  OR = 'OR',
  PW = 'PW',
  PA = 'PA',
  PR = 'PR',
  RI = 'RI',
  SC = 'SC',
  SD = 'SD',
  TN = 'TN',
  TX = 'TX',
  UT = 'UT',
  VT = 'VT',
  VI = 'VI',
  VA = 'VA',
  WA = 'WA',
  WV = 'WV',
  WI = 'WI',
  WY = 'WY',
}

export const usStateCodeToName: Record<USStateCode, string> = {
  [USStateCode.AL]: 'Alabama',
  [USStateCode.AK]: 'Alaska',
  [USStateCode.AZ]: 'Arizona',
  [USStateCode.AR]: 'Arkansas',
  [USStateCode.CA]: 'California',
  [USStateCode.CO]: 'Colorado',
  [USStateCode.CT]: 'Connecticut',
  [USStateCode.DE]: 'Delaware',
  [USStateCode.FL]: 'Florida',
  [USStateCode.GA]: 'Georgia',
  [USStateCode.HI]: 'Hawaii',
  [USStateCode.ID]: 'Idaho',
  [USStateCode.IL]: 'Illinois',
  [USStateCode.IN]: 'Indiana',
  [USStateCode.IA]: 'Iowa',
  [USStateCode.KS]: 'Kansas',
  [USStateCode.KY]: 'Kentucky',
  [USStateCode.LA]: 'Louisiana',
  [USStateCode.ME]: 'Maine',
  [USStateCode.MD]: 'Maryland',
  [USStateCode.MA]: 'Massachusetts',
  [USStateCode.MI]: 'Michigan',
  [USStateCode.MN]: 'Minnesota',
  [USStateCode.MS]: 'Mississippi',
  [USStateCode.MO]: 'Missouri',
  [USStateCode.MT]: 'Montana',
  [USStateCode.NE]: 'Nebraska',
  [USStateCode.NV]: 'Nevada',
  [USStateCode.NH]: 'New Hampshire',
  [USStateCode.NJ]: 'New Jersey',
  [USStateCode.NM]: 'New Mexico',
  [USStateCode.NY]: 'New York',
  [USStateCode.NC]: 'North Carolina',
  [USStateCode.ND]: 'North Dakota',
  [USStateCode.OH]: 'Ohio',
  [USStateCode.OK]: 'Oklahoma',
  [USStateCode.OR]: 'Oregon',
  [USStateCode.PA]: 'Pennsylvania',
  [USStateCode.RI]: 'Rhode Island',
  [USStateCode.SC]: 'South Carolina',
  [USStateCode.SD]: 'South Dakota',
  [USStateCode.TN]: 'Tennessee',
  [USStateCode.TX]: 'Texas',
  [USStateCode.UT]: 'Utah',
  [USStateCode.VT]: 'Vermont',
  [USStateCode.VA]: 'Virginia',
  [USStateCode.WA]: 'Washington',
  [USStateCode.WV]: 'West Virginia',
  [USStateCode.WI]: 'Wisconsin',
  [USStateCode.WY]: 'Wyoming',
  [USStateCode.DC]: 'District of Columbia',
  [USStateCode.AS]: 'American Samoa',
  [USStateCode.GU]: 'Guam',
  [USStateCode.MP]: 'Northern Mariana Islands',
  [USStateCode.PR]: 'Puerto Rico',
  [USStateCode.FM]: 'Federated States of Micronesia',
  [USStateCode.MH]: 'Marshall Islands',
  //   [USStateCode.UM]: 'United States Minor Outlying Islands',
  [USStateCode.VI]: 'U.S. Virgin Islands',
  [USStateCode.PW]: 'Palau',
}
